import { api as apiProvider } from '@/core/api/';

export const searchServiceLocations = async (
  fiscalYearId,
  type,
  providerId,
  municipalityId,
  serviceTypeCode,
  page
) => {
  return await apiProvider.get('/api/servicelocations', {
    params: {
      fiscalYearId,
      providerId,
      type,
      municipalityId,
      serviceTypeCode,
      page,
    },
  });
};

export const getFilteredServiceLocations = async (params) =>
  apiProvider.get('/api/servicelocations/filtered-locations', {
    params,
  });

export const getCompanyMunicipalities = async (fiscalYearId, companyId) => {
  return await apiProvider.get('api/servicelocations/municipalities', {
    params: { fiscalYearId: fiscalYearId, companyId: companyId },
  });
};

export const createContact = async (model) => {
  return await apiProvider.put('/api/servicelocations/contact', model);
};

export const editContact = async (model) => {
  return await apiProvider.post('/api/servicelocations/contact', model);
};

export const deleteContact = async (contactId) => {
  return await apiProvider.delete(`/api/servicelocations/contact/${contactId}`);
};

export const createAddress = async (model) => {
  return await apiProvider.put('/api/servicelocations/address', model);
};

export const editAddress = async (model) => {
  return await apiProvider.post('/api/servicelocations/address', model);
};

export const deleteAddress = async (addressId) => {
  return await apiProvider.delete(`/api/servicelocations/address/${addressId}`);
};

export const getServiceLocationTypes = async () => {
  return await apiProvider.get('/api/servicelocations/types');
};

export const getServicePlaces = async (params) => {
  return await apiProvider.get('/api/servicelocations/specialists/list', {
    params,
  });
};

export const getlocationservicecompany = async (fiscalYearId, companyId) => {
  return await apiProvider.get(
    `/api/servicelocations/company/${fiscalYearId}/${companyId}`
  );
};

export const getExcludedDisciplineTypes = async (locationFiscalYearId) => {
  return await apiProvider.get(
    `/api/servicelocations/excludeddisciplinetypes/${locationFiscalYearId}`
  );
};

export const updateExcludedDisciplineTypes = async (model) => {
  return await apiProvider.put(
    `api/servicelocations/updateexcludeddisciplinetypesbylocation`,
    model
  );
};

export const getlocationservicedetail = async (locationFiscalYearId) => {
  return await apiProvider.get(
    `/api/servicelocations/detail/${locationFiscalYearId}`
  );
};

export const insertservicelocation = async (model) => {
  return await apiProvider.put('/api/servicelocations/', model);
};

export const insertServiceLocationAddress = async (model) => {
  return await apiProvider.put('api/servicelocations/address', model);
};

export const deleteServiceLocationAddress = async (addressId) => {
  return await apiProvider.delete(`api/servicelocations/address/${addressId}`);
};

export const updateServiceLocationAddress = async (model) => {
  return await apiProvider.post('api/servicelocations/address', model);
};

export const insertServiceLocationContact = async (model) => {
  return await apiProvider.put('api/servicelocations/contact', model);
};

export const deleteServiceLocationContact = async (contactId) => {
  return await apiProvider.delete(`api/servicelocations/contact/${contactId}`);
};

export const updateServiceLocationContact = async (model) => {
  return await apiProvider.post('api/servicelocations/contact', model);
};

export const getSpecialistList = async (
  companyId,
  locationId,
  disciplineTypeId,
  academicYearId
) => {
  return await apiProvider.get(
    `/api/servicelocations/specialistlist/${companyId}/${locationId}/${disciplineTypeId}` +
      (academicYearId ? `?academicYearId=${academicYearId}` : '')
  );
};

export const getDisciplineList = async (
  companyId,
  locationId,
  serviceTypeId,
  academicYearId = null
) => {
  const paramsObj = academicYearId
    ? {
        params: { academicYearId },
      }
    : null;
  return await apiProvider.get(
    `/api/servicelocations/disciplinelist/${companyId}/${locationId}/${serviceTypeId}`,
    paramsObj
  );
};

export const getList = async (
  companyId,
  disciplineTypeId = null,
  municipalityId = null,
  academicYearId = null
) => {
  return await apiProvider.get(`/api/servicelocations/list/${companyId}`, {
    params: { disciplineTypeId, municipalityId, academicYearId },
  });
};

export const getDetailBySpecialist = async (params) => {
  return await apiProvider.get(`/api/servicelocations/detailbyspecialist`, {
    params,
  });
};

export const getDetailBySpecialistAndDates = async (params) => {
  return await apiProvider.get(
    `/api/providerregistryvisit/detailbyspecialistanddates`,
    {
      params,
    }
  );
};

export const saveCalendaravailability = async (model) => {
  return await apiProvider.post(
    '/api/servicelocations/savecalendaravailability',
    model
  );
};

export const removeScheduleAvailabilityByCriteria = async (model) => {
  return await apiProvider.post(
    '/api/servicelocations/removecalendaravailability',
    model
  );
};

export const movescheduleadmission = async (model) => {
  return await apiProvider.post(
    '/api/servicelocations/movescheduleadmission',
    model
  );
};

export const removeScheduleAdmission = async (model) => {
  return await apiProvider.post(
    '/api/servicelocations/removescheduleadmission',
    model
  );
};

export const getMunicipalitiesWithLocationServices = async (companyId) => {
  return await apiProvider.get(
    `/api/servicelocations/municipalities/${companyId}/providerwithlocationservices`
  );
};

export const getMunicipalityFromLocationServices = async (locationId) => {
  return await apiProvider.get(
    `/api/servicelocations/${locationId}/municipality`
  );
};
